export default "__VITE_ASSET__WYICRt7z__"